// extracted by mini-css-extract-plugin
export default {"subtitle":"M7NdOlSx7WqYi7N_rgUF","wrap":"wN2IGn6CqWtSfH3EnubW"};